module.exports = __webpack_public_path__ + "static/media/var.c1a1521e.svg";